import { useEffect, useState } from 'react';

import { differenceInMilliseconds } from 'date-fns';

const useRerenderAfterDate = (date: string) => {
  const [, setCounter] = useState(0);

  useEffect(() => {
    const delay = differenceInMilliseconds(new Date(date), new Date());

    if (delay <= 0) {
      return;
    }

    let isMounted = true;

    const timeoutId = setTimeout(() => {
      if (isMounted) {
        setCounter((oldCounter) => oldCounter + 1);
      }
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      isMounted = false;
    };
  }, [date]);
};

export default useRerenderAfterDate;
